//default environment adalah development, jika ingin menggunakan environment lain, pastikan untuk menjalankan perintah berikut di terminal sebelum menjalankan aplikasi:
// export NODE_ENV=production  (untuk Linux/MacOS)
// set NODE_ENV=production (untuk Windows)
const dev = {
  // API_ENDPOINT_URL: 'https://071cc350-ba4f-4d2a-90fd-b6547f99362c.mock.pstmn.io/v1'
  //API_ENDPOINT_URL: '/api'
  // Local endpoint
  // API_ENDPOINT_URL: 'http://192.168.2.24:89/api/los',
  // Public endpoint
  API_ENDPOINT_AUTH_URL: "http://192.168.2.71:85/api",
  API_ENDPOINT_BRANCH: "http://192.168.2.71:85/api/",

  //API_ENDPOINT_URL: "http://192.168.2.171:8080/api/los", 
  API_ENDPOINT_URL: "http://192.168.2.171:8080/api/los", 
  // API_ENDPOINT_URL: 'http://localhost:5200/api/los', //<-- contoh kalau local host
  // API_ENDPOINT_URL_INSURANCE: "http://localhost:5283/api",
  API_ENDPOINT_URL_LMS: "http://192.168.2.171:8080/api",
  // API_ENDPOINT_MOCKUO_URL: "https://mock.apidog.com/m1/388811-0-default",
  // API_ENDPOINT_URL_COLLATERAL: "http://192.168.10.55/api",
  //API_ENDPOINT_URL_INSURANCE : "http://192.168.2.171:8080/api/los",
  API_ENDPOINT_URL_INSURANCE : "http://192.168.2.171:8080/api/los",
API_ENDPOINT_URL_COLLATERAL: "http://localhost:5400/api/colmgt",
//API_ENDPOINT_URL_COLLATERAL: "http://192.168.10.125:5400/api/colmgt",
//API_ENDPOINT_URL_COLLATERAL: "http://10.96.15.128:5400/api/colmgt",
  API_ENDPOINT_URL: "http://192.168.2.171:8080/api/los",
  //API_ENDPOINT_URL: 'http://localhost:5200/api/los', //<-- contoh kalau local host
  API_ENDPOINT_URL_INSURANCE: "http://192.168.2.171:8082/api",
  
  
  API_ENDPOINT_URL_LMS: "http://192.168.2.171:8090/api",
  //API_ENDPOINT_URL_LMS: "http://localhost:7000/api",
  // API_ENDPOINT_URL_LMS: "http://localhost:8081/api",


  API_ENDPOINT_MOCKUO_URL: "https://mock.apidog.com/m1/388811-0-default",
};

const prod = {
  // API_ENDPOINT_URL: 'https://071cc350-ba4f-4d2a-90fd-b6547f99362c.mock.pstmn.io/v1'
  // API_ENDPOINT_URL: '/api/los'   <-- versi lama relative path
  // API_ENDPOINT_URL: 'http://localhost:5200/api/los' <-- contoh kalau local host
  API_ENDPOINT_AUTH_URL: "http://192.168.2.71:85/api",  // ganti agar absolute
  API_ENDPOINT_BRANCH: "http://192.168.2.71:85/api/",   // ganti agar absolute
  API_ENDPOINT_URL: "http://192.168.2.171:8080/api/los", // ganti agar absolute
  API_ENDPOINT_URL_INSURANCE: "http://192.168.2.171:8080/api/los",
  API_ENDPOINT_URL_LMS: "http://192.168.2.171:8080/api/los",
  API_ENDPOINT_MOCKUO_URL: "https://mock.apidog.com/m1/388811-0-default",
};

const test = {
  // API_ENDPOINT_URL: 'https://071cc350-ba4f-4d2a-90fd-b6547f99362c.mock.pstmn.io/v1'
  API_ENDPOINT_AUTH_URL: "/api",
  API_ENDPOINT_BRANCH: "/api",
  API_ENDPOINT_URL: "/api/los",
  //API_ENDPOINT_URL: "/api/los",
  API_ENDPOINT_MOCKUO_URL: "https://mock.apidog.com/m1/388811-0-default",
  API_ENDPOINT_URL_INSURANCE: "/api/insurance",
  API_ENDPOINT_URL_LMS: "http://localhost:5000/api",
};

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case "development":
      return dev;
    case "production":
      return prod;
    case "test":
      return test;
    default:
      return dev;
  }
};


export const env = getEnv();
